/**
 * @generated SignedSource<<7c966eddca120a2bebae8c5bb1c3fd4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vendorAccountId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "VendorIssuesResultsConnection",
    "kind": "LinkedField",
    "name": "vendorissuessearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VendorIssuesResult",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "problemType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "problemCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardVendorProblemsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardVendorProblemsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d96037b0c6b053da0a19c1fc71f1eb45",
    "id": null,
    "metadata": {},
    "name": "DashboardVendorProblemsQuery",
    "operationKind": "query",
    "text": "query DashboardVendorProblemsQuery(\n  $vendorAccountId: UUID!\n) {\n  vendorissuessearch(vendoraccountid: $vendorAccountId) {\n    totalCount\n    nodes {\n      accountId\n      accountName\n      problemType\n      problemCount\n    }\n  }\n}\n"
  }
};
})();

node.hash = "7f750d0dfca268aa861ef1d79ba382a5";

module.exports = node;
